import { render, staticRenderFns } from "./GCPinf.vue?vue&type=template&id=4d3b4ded&"
import script from "./GCPinf.vue?vue&type=script&lang=js&"
export * from "./GCPinf.vue?vue&type=script&lang=js&"
import style0 from "./GCPinf.vue?vue&type=style&index=0&id=4d3b4ded&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports